export const LOGIN_PAGE_NOTICE_BANNER_ENABLED: boolean =
    process.env.REACT_APP_LOGIN_PAGE_NOTICE_BANNER_ENABLED === "true" || false;
